import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output"]
  static values = { end: String }

  connect() {
    this.render()
    this.timer = window.setInterval(() => this.render(), 1000)
  }

  disconnect() {
    window.clearInterval(this.timer)
  }

  render() {
    const remaining = new Date(this.endValue).getTime() - Date.now()

    if (remaining <= 0) {
      this.outputTarget.textContent = "Expired"
      window.clearInterval(this.timer)
      return
    }

    const days = Math.floor(remaining / 86400000)
    const hours = Math.floor((remaining % 86400000) / 3600000)
    const minutes = Math.floor((remaining % 3600000) / 60000)
    const seconds = Math.floor((remaining % 60000) / 1000)
    this.outputTarget.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`
  }
}
